import { Controller } from "@hotwired/stimulus"

// Bandeau de soutien (excuses perfs + café). La croix le ferme pour
// REAPPEAR_MS seulement : il revient à la page suivante passé ce délai.
// Clics et fermetures comptés via le beacon.
const REAPPEAR_MS = 10 * 60 * 1000 // 10 minutes

export default class extends Controller {
  static values = { key: String }

  connect() {
    try {
      const dismissedAt = parseInt(localStorage.getItem(this.keyValue) || "0", 10)
      if (dismissedAt && Date.now() - dismissedAt < REAPPEAR_MS) return
    } catch (e) {}
    this.element.hidden = false
    this.beacon("banner_shown")
  }

  dismiss() {
    this.close()
    this.beacon("banner_dismissed")
  }

  donate() {
    // Le lien s'ouvre dans un nouvel onglet (href) ; on compte seulement —
    // le bandeau reste affiché, seule la croix le ferme.
    this.beacon("banner_clicked")
  }

  close() {
    this.element.hidden = true
    try { localStorage.setItem(this.keyValue, String(Date.now())) } catch (e) {}
  }

  beacon(event) {
    try { navigator.sendBeacon("/track/support", new URLSearchParams({ event })) } catch (e) {}
  }
}
